export default __webpack_public_path__ + "static/media/tenants.c2ed0f61.svg";